<template>
  <iframe id="wrapperWebdoc" src="http://155.253.11.103/webdoc/" class="webdoc"></iframe>
</template>

<script>
  export default {
    name: 'GalleryPage'
  }
</script>

<style scoped>

  .webdoc {
    width: 100%;
    height: 85vh;
    margin: 0 !important;
    -webkit-transition: .5s; /* Safari prior 6.1 */
    transition: .5s;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/galleryPageComponents/GalleryPage.vue